import { render, staticRenderFns } from "./submissionChecklist.vue?vue&type=template&id=2d478ed0&scoped=true&lang=html"
import script from "./submissionChecklist.vue?vue&type=script&lang=js"
export * from "./submissionChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d478ed0",
  null
  
)

export default component.exports